import React from 'react';

import Loader from './Loader';

const Container = ({ children }) => <section>{children}</section>;

const Heading = ({ heading }) => {
  if (!heading) return null;

  const { text, link } = heading;

  if (link) {
    return (
      <p className="t-sectionhead t-size-b t-uppercase t-lsp-b t-weight-bold has-b-btm-marg">
        <a className="has-text-black" href={link}>
          {text}
        </a>
      </p>
    );
  }
  return (
    <p className="t-sectionhead t-size-b t-uppercase t-lsp-b t-weight-bold has-b-btm-marg">
      {text}
    </p>
  );
};

const ListInner = ({ children }) => (
  <ul className="c-block-feed has-b-btm-marg">{children}</ul>
);

const ListItem = ({ url, hed, date, thumb, ga: { action, label } }) => (
  <li className="c-block-feed__item">
    <div className="c-story-block has-text-gray-dark">
      <div className="c-story-block__text">
        <h3 className="c-story-block__headline t-serif has-b-btm-marg t-serif">
          <a
            className="has-text-hover-black"
            href={url}
            ga-on="click"
            ga-event-category="read more"
            ga-event-action={action}
            ga-event-label={label}
          >
            {hed}
          </a>
        </h3>
        <time className="t-uppercase t-lsp-m t-size-xs has-text-vert-padding">
          {date}
        </time>
      </div>
      <figure className="c-story-block__wrap">
        <a
          href={url}
          ga-on="click"
          ga-event-category="read more"
          ga-event-action={action}
          ga-event-label={label}
        >
          <img alt={hed} className="l-width-full" src={thumb} />
        </a>
      </figure>
    </div>
  </li>
);

const RelatedList = ({
  useUpdatedDate,
  heading,
  ga,
  dataFetch: { isPending, data },
}) => {
  if (isPending) {
    return (
      <Container>
        <Heading heading={heading} />
        <Loader />
      </Container>
    );
  }

  return (
    <Container>
      <Heading heading={heading} />
      <ListInner>
        {data.map(({ id, url, hed, thumb, date, updatedDate }) => (
          <ListItem
            key={id}
            url={url}
            hed={hed}
            thumb={thumb}
            date={(useUpdatedDate && updatedDate) || date}
            ga={ga}
          />
        ))}
      </ListInner>
    </Container>
  );
};

export default RelatedList;
